import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Slider,
  Button,
  Tooltip,
} from '@mui/material';
import { FilterAlt, RestartAlt } from '@mui/icons-material';

const PLANS = ['ALL', 'A', 'B', 'C'];
const SPECIES = [
  'ALL',
  'VANNAMEI',
  'MONODON',
  'ROHU',
  'CATLA',
  'MRIGAL',
  'PANGASIUS',
  'TILAPIA',
];

const RiskFilters = ({ filters, onChange, districts = [], onReset }) => {
  const set = (key, value) => onChange({ ...filters, [key]: value });

  const isDefault =
    filters.plan === 'ALL' &&
    filters.species === 'ALL' &&
    filters.district === 'ALL' &&
    filters.docRange[0] === 0 &&
    filters.docRange[1] === 180;

  return (
    <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
      <div className="flex items-center gap-2 mb-3">
        <FilterAlt sx={{ fontSize: 18, color: '#6366f1' }} />
        <span className="text-sm font-semibold text-gray-700">Filters</span>
        {!isDefault && (
          <Tooltip title="Reset all filters">
            <Button
              size="small"
              startIcon={<RestartAlt sx={{ fontSize: 14 }} />}
              onClick={onReset}
              sx={{ ml: 'auto', textTransform: 'none', fontSize: 12 }}
            >
              Reset
            </Button>
          </Tooltip>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Plan Type */}
        <FormControl size="small" fullWidth>
          <InputLabel>Plan Type</InputLabel>
          <Select
            value={filters.plan}
            label="Plan Type"
            onChange={(e) => set('plan', e.target.value)}
            sx={{ borderRadius: 2 }}
          >
            {PLANS.map((p) => (
              <MenuItem key={p} value={p}>
                {p === 'ALL' ? 'All Plans' : `Plan ${p}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Species */}
        <FormControl size="small" fullWidth>
          <InputLabel>Species</InputLabel>
          <Select
            value={filters.species}
            label="Species"
            onChange={(e) => set('species', e.target.value)}
            sx={{ borderRadius: 2 }}
          >
            {SPECIES.map((s) => (
              <MenuItem key={s} value={s}>
                {s === 'ALL' ? 'All Species' : s.charAt(0) + s.slice(1).toLowerCase()}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* District */}
        <FormControl size="small" fullWidth>
          <InputLabel>District</InputLabel>
          <Select
            value={filters.district}
            label="District"
            onChange={(e) => set('district', e.target.value)}
            sx={{ borderRadius: 2 }}
          >
            <MenuItem value="ALL">All Districts</MenuItem>
            {districts.map((d) => (
              <MenuItem key={d} value={d}>
                {d}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* DOC Range */}
        <div className="flex flex-col justify-center px-2">
          <div className="flex items-center justify-between mb-1">
            <span className="text-xs text-gray-500 font-medium">DOC Range</span>
            <span className="text-xs text-indigo-600 font-semibold">
              {filters.docRange[0]}–{filters.docRange[1]} days
            </span>
          </div>
          <Slider
            value={filters.docRange}
            onChange={(_, val) => set('docRange', val)}
            min={0}
            max={180}
            step={10}
            size="small"
            valueLabelDisplay="auto"
            sx={{
              color: '#6366f1',
              '& .MuiSlider-thumb': { width: 14, height: 14 },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default RiskFilters;
